import React from 'react';
import ProgressProfile from '../../ProgressProfile/';
import ExpIconBottom from '../../../components/ExpIconBottom';
import TitlesProfile from '../../../components/Profile/TitlesProfile/';
//import CardProfile from '../../../components/Profile/Card/';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import * as ROUTES from '../../../routes/';
import { connect } from 'react-redux';

const useStyles = makeStyles({
  awardIconContainer: {
    //marginBottom: 32,
    display: 'flex',
    //flexFlow: 'column',
    //alignItems: 'center',
    //flexGrow: 1,
    padding: '0 32px',
  },
  progressContent: {
    //maxWidth: 792,
    display: 'flex',
    justifyContent: 'space-evenly',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    paddingTop: 8,
  },
  awardImage: {
    width: 52,
    height: 52,
    marginRight: 8
  }
});

function Progress(props) {
  const classes = useStyles(props);
  const { 
    authClient: { 
      awardPerfil: {
        look,
        about,
        experience,
        contact,
        holder,
        collaborators,
        site,
      },
      awardAditional: {
        cost,
        pictures,
        videos,
        shareProfile,
        highQualification,
      },
      role,
    }
  } = props ;
  
  const calculateProfileAchievements = () => {
    const array = [look, about, experience, contact, holder, collaborators, site];
    const quantity = array.filter(element => element)
    return quantity.length
  }

  const calculateAditionalAchievements = () => {
    const array = [cost, pictures, videos, shareProfile, highQualification];
    const quantity = array.filter(element => element)
    return quantity.length
  }

  let PROFILE_LIMIT
  if (role === 'lawyer') {
    PROFILE_LIMIT = 5
  } else {
    PROFILE_LIMIT = 7
  }
  
  const ACHIEVEMENTS_LIMIT = 5

  return (
    <>
      <div className="progress" id="progress">
        <ExpIconBottom 
        sumcontent = {
          <>
          <TitlesProfile 
            title='Logros'
            subtitle={role === 'lawFirm' ?
              'Puedes obtener logros por cada dato que aportas a tu perfil o por tareas adicionales.' :
              'Al ir completando tu perfil, podrás desbloquear logros que te permitirán visualizar tu progreso y tener mayor presencia en los listados generales de las búsquedas.'
            }
            
          />
          <div className={classes.progressContent}>
            <div className={classes.awardIconContainer}>
              {PROFILE_LIMIT === calculateProfileAchievements() ?
                <img
                  src="/img/profile/progress/completo-sm.svg"
                  alt="logros"
                  className={classes.awardImage}
                /> :
                <img
                  src="/img/profile/progress/desabilitado-lg.svg"
                  alt="logros"
                  className={classes.awardImage}
                />
              }
              <p style={{ color: '#10587f', fontSize: 18, fontWeight: 'bold' }}>
                <span style={{fontSize:26}}>{calculateProfileAchievements()}/{PROFILE_LIMIT}</span>
              <br/>Logros perfil</p>
            </div>

            <div className={classes.awardIconContainer}>
              {ACHIEVEMENTS_LIMIT === calculateAditionalAchievements() ?
                <img
                  src="/img/profile/progress/completo-sm.svg"
                  alt="logros"
                  className={classes.awardImage}
                /> :
                <img
                  src="/img/profile/progress/desabilitado-lg.svg"
                  alt="logros"
                  className={classes.awardImage}
                />
              }
              <p style={{ color: '#10587f', fontSize: 18, fontWeight: 'bold'}}>
                <span style={{fontSize:26}}>{calculateAditionalAchievements()}/{ACHIEVEMENTS_LIMIT}</span>
              <br/>Adicionales</p>
            </div>
            
          </div>
            </>
        }
        detcontent = {
          <ProgressProfile />
        }
        expansionButton
        />
      </div>
    </>
  );
}

const mapStateToProps = state => ({
  authClient: state.authClient,
})

export default connect(mapStateToProps, null)(Progress);
